var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.542969 7.019531 L 29.472656 7.019531 L 29.472656 22.261719 L 0.542969 22.261719 Z M 0.542969 7.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.570312 14.652344 C 0.570312 18.863281 7.035156 22.273438 15.007812 22.273438 C 22.980469 22.273438 29.445312 18.863281 29.445312 14.652344 C 29.445312 10.441406 22.980469 7.03125 15.007812 7.03125 C 7.035156 7.03125 0.570312 10.441406 0.570312 14.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.570312 14.652344 C 0.570312 18.863281 7.035156 22.273438 15.007812 22.273438 C 22.980469 22.273438 29.445312 18.863281 29.445312 14.652344 C 29.445312 10.441406 22.980469 7.03125 15.007812 7.03125 C 7.035156 7.03125 0.570312 10.441406 0.570312 14.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0.99824, 0, 0, 1.00176, 9.237661, 9.710042)",
    gradientUnits: "userSpaceOnUse",
    r: 18.993025,
    cx: 0,
    id: "id4",
    cy: 0,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.199158%, 69.799805%, 83.499146%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.199158%, 69.799805%, 83.499146%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.164062%, 69.764709%, 83.473206%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.956543%, 69.555664%, 83.317566%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.608643%, 69.20929%, 83.059692%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.260742%, 68.861389%, 82.800293%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.914368%, 68.513489%, 82.542419%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.566467%, 68.167114%, 82.28302%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.220093%, 67.819214%, 82.025146%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.872192%, 67.472839%, 81.765747%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.525818%, 67.124939%, 81.506348%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.177917%, 66.778564%, 81.248474%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.831543%, 66.430664%, 80.989075%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.483643%, 66.08429%, 80.731201%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.135742%, 65.736389%, 80.471802%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.789368%, 65.388489%, 80.213928%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.441467%, 65.042114%, 79.954529%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.095093%, 64.694214%, 79.696655%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.747192%, 64.347839%, 79.437256%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.400818%, 63.999939%, 79.179382%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.052917%, 63.653564%, 78.919983%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.706543%, 63.305664%, 78.662109%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.358643%, 62.95929%, 78.40271%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.010742%, 62.611389%, 78.144836%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.664368%, 62.263489%, 77.885437%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.316467%, 61.917114%, 77.627563%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.970093%, 61.569214%, 77.368164%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.622192%, 61.222839%, 77.108765%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.275818%, 60.874939%, 76.850891%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.927917%, 60.528564%, 76.591492%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.581543%, 60.180664%, 76.333618%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.233643%, 59.83429%, 76.074219%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.885742%, 59.486389%, 75.816345%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.539368%, 59.138489%, 75.556946%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.191467%, 58.792114%, 75.299072%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.845093%, 58.444214%, 75.039673%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.497192%, 58.097839%, 74.781799%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.150818%, 57.749939%, 74.5224%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.802917%, 57.403564%, 74.264526%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.456543%, 57.055664%, 74.005127%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.108643%, 56.70929%, 73.747253%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.760742%, 56.361389%, 73.487854%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.414368%, 56.013489%, 73.22998%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.066467%, 55.667114%, 72.970581%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.720093%, 55.319214%, 72.711182%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.372192%, 54.972839%, 72.453308%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.025818%, 54.624939%, 72.193909%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.677917%, 54.278564%, 71.936035%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.331543%, 53.930664%, 71.676636%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.983643%, 53.58429%, 71.418762%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.635742%, 53.236389%, 71.159363%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.289368%, 52.888489%, 70.901489%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.941467%, 52.542114%, 70.64209%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.595093%, 52.194214%, 70.384216%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.247192%, 51.847839%, 70.124817%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.900818%, 51.499939%, 69.866943%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.552917%, 51.153564%, 69.607544%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.206543%, 50.805664%, 69.34967%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.858643%, 50.45929%, 69.090271%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.510742%, 50.111389%, 68.832397%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.164368%, 49.763489%, 68.572998%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.816467%, 49.417114%, 68.313599%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.470093%, 49.069214%, 68.055725%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.122192%, 48.722839%, 67.796326%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.775818%, 48.374939%, 67.538452%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.427917%, 48.028564%, 67.279053%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.081543%, 47.680664%, 67.021179%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.733643%, 47.33429%, 66.76178%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.385742%, 46.986389%, 66.503906%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.039368%, 46.638489%, 66.244507%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.691467%, 46.292114%, 65.986633%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.345093%, 45.944214%, 65.727234%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.997192%, 45.597839%, 65.46936%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.650818%, 45.249939%, 65.209961%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.302917%, 44.903564%, 64.952087%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.956543%, 44.555664%, 64.692688%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.608643%, 44.20929%, 64.434814%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.260742%, 43.861389%, 64.175415%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.914368%, 43.513489%, 63.916016%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.566467%, 43.167114%, 63.658142%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.220093%, 42.819214%, 63.398743%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.872192%, 42.472839%, 63.140869%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.525818%, 42.124939%, 62.88147%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.177917%, 41.778564%, 62.623596%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.831543%, 41.430664%, 62.364197%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.483643%, 41.08429%, 62.106323%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.135742%, 40.736389%, 61.846924%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.789368%, 40.388489%, 61.58905%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.441467%, 40.042114%, 61.329651%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.095093%, 39.694214%, 61.071777%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.747192%, 39.347839%, 60.812378%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.400818%, 38.999939%, 60.554504%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.052917%, 38.653564%, 60.295105%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.706543%, 38.305664%, 60.037231%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.358643%, 37.95929%, 59.777832%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.010742%, 37.611389%, 59.518433%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.664368%, 37.263489%, 59.260559%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.316467%, 36.917114%, 59.00116%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.970093%, 36.569214%, 58.743286%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.622192%, 36.222839%, 58.483887%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.275818%, 35.874939%, 58.226013%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.927917%, 35.528564%, 57.966614%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.581543%, 35.180664%, 57.70874%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.233643%, 34.83429%, 57.449341%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.885742%, 34.486389%, 57.191467%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.539368%, 34.138489%, 56.932068%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.191467%, 33.792114%, 56.674194%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.845093%, 33.444214%, 56.414795%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.497192%, 33.097839%, 56.156921%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.150818%, 32.749939%, 55.897522%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.802917%, 32.403564%, 55.639648%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.456543%, 32.055664%, 55.380249%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.108643%, 31.70929%, 55.122375%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.760742%, 31.361389%, 54.862976%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.414368%, 31.013489%, 54.603577%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.066467%, 30.667114%, 54.345703%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.720093%, 30.319214%, 54.086304%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.372192%, 29.972839%, 53.82843%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.199768%, 29.798889%, 53.69873%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 7.019531 L 29 7.019531 L 29 22 L 1 22 Z M 1 7.019531 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id4)",
    d: "M 0.570312 7.03125 L 0.570312 22.261719 L 29.445312 22.261719 L 29.445312 7.03125 Z M 0.570312 7.03125 ",
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#777bb3",
    d: "M 15.007812 21.707031 C 22.667969 21.707031 28.882812 18.550781 28.882812 14.652344 C 28.882812 10.753906 22.667969 7.597656 15.007812 7.597656 C 7.34375 7.597656 1.132812 10.753906 1.132812 14.652344 C 1.132812 18.550781 7.34375 21.707031 15.007812 21.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 8.414062 15.527344 C 9.042969 15.527344 9.511719 15.410156 9.8125 15.179688 C 10.105469 14.953125 10.308594 14.558594 10.414062 14.007812 C 10.515625 13.496094 10.476562 13.136719 10.304688 12.941406 C 10.125 12.746094 9.742188 12.644531 9.160156 12.644531 L 8.152344 12.644531 L 7.59375 15.527344 Z M 5.121094 19.078125 C 5.074219 19.078125 5.027344 19.058594 5 19.019531 C 4.96875 18.980469 4.957031 18.9375 4.964844 18.890625 L 6.445312 11.253906 C 6.460938 11.167969 6.511719 11.125 6.597656 11.125 L 9.789062 11.125 C 10.789062 11.125 11.535156 11.398438 12.003906 11.9375 C 12.476562 12.476562 12.621094 13.234375 12.4375 14.1875 C 12.363281 14.574219 12.234375 14.933594 12.054688 15.253906 C 11.875 15.578125 11.636719 15.875 11.347656 16.144531 C 11.003906 16.46875 10.613281 16.703125 10.1875 16.839844 C 9.769531 16.976562 9.230469 17.046875 8.589844 17.046875 L 7.300781 17.046875 L 6.933594 18.949219 C 6.914062 19.035156 6.863281 19.078125 6.777344 19.078125 Z M 5.121094 19.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 8.28125 12.800781 L 9.160156 12.800781 C 9.859375 12.800781 10.105469 12.957031 10.1875 13.046875 C 10.324219 13.199219 10.351562 13.523438 10.261719 13.980469 C 10.164062 14.492188 9.980469 14.851562 9.714844 15.054688 C 9.445312 15.265625 9.007812 15.371094 8.414062 15.371094 L 7.785156 15.371094 Z M 9.789062 10.96875 L 6.597656 10.96875 C 6.425781 10.96875 6.324219 11.050781 6.292969 11.222656 L 4.8125 18.859375 C 4.792969 18.957031 4.816406 19.042969 4.878906 19.121094 C 4.941406 19.195312 5.023438 19.234375 5.121094 19.234375 L 6.777344 19.234375 C 6.949219 19.234375 7.054688 19.152344 7.085938 18.980469 L 7.429688 17.203125 L 8.589844 17.203125 C 9.25 17.203125 9.800781 17.132812 10.234375 16.992188 C 10.679688 16.84375 11.09375 16.597656 11.457031 16.257812 C 11.753906 15.980469 12.003906 15.667969 12.191406 15.332031 C 12.378906 14.996094 12.511719 14.621094 12.589844 14.214844 C 12.785156 13.214844 12.628906 12.414062 12.121094 11.832031 C 11.621094 11.257812 10.835938 10.96875 9.789062 10.96875 M 7.40625 15.683594 L 8.414062 15.683594 C 9.082031 15.683594 9.578125 15.558594 9.90625 15.304688 C 10.234375 15.054688 10.453125 14.632812 10.570312 14.039062 C 10.679688 13.472656 10.628906 13.070312 10.417969 12.839844 C 10.210938 12.605469 9.789062 12.488281 9.160156 12.488281 L 8.023438 12.488281 L 7.40625 15.683594 M 9.789062 11.28125 C 10.746094 11.28125 11.445312 11.535156 11.886719 12.039062 C 12.328125 12.546875 12.457031 13.25 12.285156 14.15625 C 12.210938 14.527344 12.089844 14.871094 11.917969 15.179688 C 11.746094 15.488281 11.519531 15.769531 11.242188 16.027344 C 10.910156 16.339844 10.542969 16.558594 10.136719 16.691406 C 9.734375 16.824219 9.21875 16.890625 8.59375 16.890625 L 7.171875 16.890625 L 6.777344 18.921875 L 5.121094 18.921875 L 6.601562 11.285156 L 9.789062 11.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 16.238281 17.046875 C 16.191406 17.046875 16.148438 17.027344 16.117188 16.988281 C 16.089844 16.953125 16.074219 16.90625 16.085938 16.859375 L 16.738281 13.480469 C 16.800781 13.160156 16.785156 12.929688 16.695312 12.832031 C 16.640625 12.769531 16.476562 12.671875 15.984375 12.671875 L 14.800781 12.671875 L 13.976562 16.917969 C 13.960938 17.003906 13.910156 17.046875 13.824219 17.046875 L 12.179688 17.046875 C 12.128906 17.046875 12.089844 17.027344 12.058594 16.988281 C 12.027344 16.953125 12.015625 16.90625 12.023438 16.859375 L 13.503906 9.222656 C 13.519531 9.136719 13.570312 9.09375 13.65625 9.09375 L 15.300781 9.09375 C 15.351562 9.09375 15.390625 9.113281 15.421875 9.152344 C 15.453125 9.191406 15.464844 9.234375 15.457031 9.28125 L 15.097656 11.125 L 16.375 11.125 C 17.347656 11.125 18.003906 11.296875 18.390625 11.652344 C 18.78125 12.011719 18.902344 12.589844 18.75 13.367188 L 18.0625 16.917969 C 18.046875 17.003906 17.996094 17.046875 17.910156 17.046875 Z M 16.238281 17.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 15.300781 8.9375 L 13.65625 8.9375 C 13.484375 8.9375 13.382812 9.023438 13.351562 9.191406 L 11.871094 16.828125 C 11.851562 16.925781 11.875 17.011719 11.9375 17.089844 C 12 17.164062 12.078125 17.203125 12.179688 17.203125 L 13.824219 17.203125 C 13.996094 17.203125 14.097656 17.121094 14.132812 16.949219 L 14.929688 12.828125 L 15.984375 12.828125 C 16.472656 12.828125 16.578125 12.933594 16.582031 12.9375 C 16.609375 12.96875 16.648438 13.117188 16.585938 13.449219 L 15.929688 16.828125 C 15.914062 16.925781 15.933594 17.011719 15.996094 17.089844 C 16.058594 17.164062 16.140625 17.203125 16.238281 17.203125 L 17.910156 17.203125 C 18.082031 17.203125 18.183594 17.121094 18.21875 16.949219 L 18.90625 13.394531 C 19.066406 12.5625 18.929688 11.933594 18.496094 11.535156 C 18.082031 11.152344 17.386719 10.96875 16.375 10.96875 L 15.289062 10.96875 L 15.609375 9.3125 C 15.628906 9.214844 15.605469 9.128906 15.542969 9.050781 C 15.480469 8.976562 15.402344 8.9375 15.304688 8.9375 M 15.304688 9.25 L 14.910156 11.28125 L 16.375 11.28125 C 17.296875 11.28125 17.933594 11.445312 18.285156 11.765625 C 18.632812 12.089844 18.738281 12.613281 18.597656 13.335938 L 17.910156 16.890625 L 16.238281 16.890625 L 16.894531 13.511719 C 16.96875 13.125 16.941406 12.863281 16.8125 12.722656 C 16.683594 12.582031 16.40625 12.515625 15.984375 12.515625 L 14.671875 12.515625 L 13.824219 16.890625 L 12.179688 16.890625 L 13.65625 9.25 L 15.300781 9.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.355469 15.527344 C 21.984375 15.527344 22.453125 15.410156 22.753906 15.179688 C 23.046875 14.953125 23.25 14.558594 23.355469 14.007812 C 23.457031 13.496094 23.417969 13.136719 23.246094 12.941406 C 23.066406 12.746094 22.683594 12.644531 22.101562 12.644531 L 21.09375 12.644531 L 20.535156 15.527344 Z M 18.0625 19.078125 C 18.015625 19.078125 17.96875 19.054688 17.941406 19.019531 C 17.910156 18.980469 17.898438 18.9375 17.90625 18.890625 L 19.386719 11.253906 C 19.402344 11.167969 19.453125 11.125 19.539062 11.125 L 22.730469 11.125 C 23.730469 11.125 24.476562 11.398438 24.945312 11.9375 C 25.417969 12.476562 25.5625 13.234375 25.378906 14.1875 C 25.304688 14.574219 25.175781 14.933594 24.996094 15.253906 C 24.816406 15.578125 24.578125 15.875 24.289062 16.144531 C 23.945312 16.46875 23.554688 16.703125 23.128906 16.839844 C 22.710938 16.976562 22.171875 17.046875 21.53125 17.046875 L 20.242188 17.046875 L 19.871094 18.949219 C 19.855469 19.035156 19.804688 19.078125 19.71875 19.078125 Z M 18.0625 19.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.222656 12.800781 L 22.101562 12.800781 C 22.800781 12.800781 23.046875 12.957031 23.128906 13.046875 C 23.265625 13.199219 23.292969 13.523438 23.203125 13.980469 C 23.105469 14.492188 22.921875 14.851562 22.65625 15.054688 C 22.386719 15.265625 21.949219 15.371094 21.355469 15.371094 L 20.726562 15.371094 Z M 22.730469 10.96875 L 19.539062 10.96875 C 19.367188 10.96875 19.265625 11.050781 19.234375 11.222656 L 17.753906 18.859375 C 17.734375 18.957031 17.757812 19.042969 17.820312 19.121094 C 17.882812 19.195312 17.960938 19.234375 18.0625 19.234375 L 19.71875 19.234375 C 19.890625 19.234375 19.992188 19.152344 20.027344 18.980469 L 20.371094 17.203125 L 21.53125 17.203125 C 22.191406 17.203125 22.742188 17.132812 23.175781 16.992188 C 23.621094 16.84375 24.035156 16.597656 24.398438 16.257812 C 24.695312 15.980469 24.945312 15.667969 25.132812 15.332031 C 25.320312 14.996094 25.453125 14.621094 25.53125 14.214844 C 25.726562 13.214844 25.570312 12.414062 25.0625 11.832031 C 24.5625 11.257812 23.777344 10.96875 22.730469 10.96875 M 20.347656 15.683594 L 21.355469 15.683594 C 22.023438 15.683594 22.519531 15.558594 22.847656 15.304688 C 23.175781 15.054688 23.394531 14.632812 23.511719 14.039062 C 23.621094 13.472656 23.570312 13.070312 23.359375 12.839844 C 23.152344 12.605469 22.730469 12.488281 22.101562 12.488281 L 20.964844 12.488281 L 20.347656 15.683594 M 22.730469 11.28125 C 23.6875 11.28125 24.386719 11.535156 24.828125 12.039062 C 25.269531 12.546875 25.398438 13.25 25.222656 14.15625 C 25.152344 14.527344 25.03125 14.871094 24.859375 15.179688 C 24.6875 15.488281 24.460938 15.769531 24.183594 16.027344 C 23.851562 16.339844 23.484375 16.558594 23.078125 16.691406 C 22.675781 16.824219 22.160156 16.890625 21.53125 16.890625 L 20.113281 16.890625 L 19.71875 18.921875 L 18.0625 18.921875 L 19.539062 11.28125 L 22.730469 11.28125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.23c07fbb2198d640957a30583e784434.svg";
export { ForwardRef as ReactComponent };